module.exports = __webpack_public_path__ + "img/553.1c245377.jpg";